import { Controller } from "../vendor/stimulus.js";
import { scrollTo, scrollToTop } from "../modules/scroll_to.js";
import Effects from "../modules/effects.js";

export default class extends Controller {
  static targets = [
    "flashNotice",
    "scrollButton",
    "entrySelection",
    "promptOnlyContainer",
    "welcomeSection",
    "moodboardSection",
  ];

  connect() {
    this.lastScrollY = window.scrollY;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleXhrFailed = this.onXhrFailed.bind(this);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("xhr-failed", this.handleXhrFailed);
    this.updateButtonState();
    this.scrollThreshold = 200;
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("xhr-failed", this.handleXhrFailed);
  }

  skipMoodboard(event) {
    event.preventDefault();
    Effects.slideDown(this.promptOnlyContainerTarget);
    Effects.slideUpFade(this.entrySelectionTarget);

    setTimeout(() => {
      scrollToTop({ duration: 400, easing: "easeInOutSine" });
    }, 0);
  }

  showUploadDialog() {
    this.element.classList.add("show-moodboard-upload-dialog", "moodboard-upload-is-loading");
    scrollTo(-1);
    setTimeout(() => {
      this.element.classList.remove("moodboard-upload-is-loading");
    }, 3000);
  }

  hideUploadDialog() {
    this.element.classList.remove("show-moodboard-upload-dialog", "moodboard-upload-is-loading");
  }

  showMoodboardSection() {
    this.welcomeSectionTarget.style.display = "none";
    this.moodboardSectionTarget.classList.remove("hidden");
    this.hideUploadDialog();
    this.element.classList.add("unveil-moodboard");

    const moodboard = this.moodboardSectionTarget.querySelector('.moodboard');
    if (moodboard) {
      moodboard.classList.add('is-loading');
    }
  }

  handleScroll() {
    const previousScrollY = this.lastScrollY;
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > previousScrollY;
    this.lastScrollY = currentScrollY;
    this.updateButtonState(isScrollingDown ? "down" : "up");
  }

  updateButtonState(direction = null) {
    if (!this.hasScrollButtonTarget) return;

    const scrolledPastThreshold = window.scrollY > this.scrollThreshold;

    const documentElement = document.documentElement;
    const scrollHeight = documentElement.scrollHeight;
    const scrolledPosition = window.scrollY + window.innerHeight;
    const nearBottom = scrolledPosition >= scrollHeight - this.scrollThreshold;

    if (scrolledPastThreshold && direction === "up") {
      this.scrollButtonTarget.classList.add("show-scroll-button");
    }

    if (nearBottom) {
      this.scrollButtonTarget.classList.remove("show-scroll-button");
    }
  }

  scrollToBottom(event) {
    event?.preventDefault?.();
    const documentElement = document.documentElement;
    const maxScroll = Math.max(0, documentElement.scrollHeight - window.innerHeight);
    scrollTo(maxScroll, { duration: 360, easing: "easeInOutSine" });
  }

  onXhrFailed(event) {
    this.flashNoticeTarget.classList.add("show-flash-notice")
    console.warn("XHR failed", event?.detail);
  }

  handleReset(event) {
    event.preventDefault();
    const shopUrl = window.location.href;
    window.location.href = '/reset?return_to=' + encodeURIComponent(shopUrl);
  }
}
